module.exports = __webpack_public_path__ + "img/Linda Edmonds Turner (1).e3a81f01.png";